import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import interfaceReducer from './InterfaceSlice'
import dataReducer from './DataSlice'
import authenticationReducer from './AuthenticationSlice'

export const store = configureStore({
  reducer: {
    interface: interfaceReducer,
    data: dataReducer,
    authentication: authenticationReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
